import { useSelector } from 'react-redux';
import { DNT_FILTERS } from '../utils';
import {
  DsoNameFilter, DsoRAMFilter, FilterSelect, RamFilter,
} from '../../../commonComponents/filters';

/**
 * Reads the DSO manager list; it does not fetch it.
 *
 * This used to guard its own `if (!dsoManagerList) dispatch(...)` refetch. That
 * was dead code — the reducer initialises the slice to `[]`, which is truthy —
 * and it could not be made live safely: child effects run before parent
 * effects, so it fired before `useAppBootstrap` and double-requested the list
 * rather than filling a gap. `AppShell` is always mounted and is the one place
 * that loads shared reference data.
 */
export const DNTCustomFilters = ({ filter, handleFilterChange }) => {
  const dsoManagerList = useSelector((state) => state.users.dsoManagers);

  return (
    <>
      <RamFilter filter={filter} handleFilterChange={handleFilterChange} />

      <DsoNameFilter filter={filter} handleFilterChange={handleFilterChange} />

      <DsoRAMFilter filter={filter} handleFilterChange={handleFilterChange} />

      {DNT_FILTERS({ dsoManagerList })?.map(({ key, label, options }) => (
        <FilterSelect
          key={key}
          id={key}
          label={label}
          options={options}
          value={filter[key]}
          onChange={handleFilterChange}
        />
      ))}
    </>
  );
};
